import { supabase } from '../lib/supabase';

export const qrScanService = {
  // Create QR scan record
  async createScan(scanData) {
    const { data, error } = await supabase?.from('qr_scans')?.insert({
        business_id: scanData?.businessId,
        user_id: scanData?.userId,
        customer_name: scanData?.customerName,
        customer_id_number: scanData?.customerIdNumber,
        customer_whatsapp: scanData?.customerWhatsapp,
        membership_tier: scanData?.membershipTier
      })?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      businessId: data?.business_id,
      userId: data?.user_id,
      scanDate: data?.scan_date
    };
  },

  // Get scans for business
  async getBusinessScans(businessId, limit = 50) {
    const { data, error } = await supabase?.from('qr_scans')?.select('*')?.eq('business_id', businessId)?.order('scan_date', { ascending: false })?.limit(limit);
    
    if (error) throw error;
    
    return data?.map(scan => ({
      id: scan?.id,
      businessId: scan?.business_id,
      userId: scan?.user_id,
      customerName: scan?.customer_name,
      customerIdNumber: scan?.customer_id_number,
      customerWhatsapp: scan?.customer_whatsapp,
      membershipTier: scan?.membership_tier,
      scanDate: scan?.scan_date
    }));
  },

  // Get analytics for business
  async getBusinessAnalytics(businessId, startDate, endDate) {
    const { data, error } = await supabase?.from('business_analytics')?.select('*')?.eq('business_id', businessId)?.gte('date', startDate)?.lte('date', endDate)?.order('date', { ascending: true });
    
    if (error) throw error;
    
    return data?.map(analytics => ({
      id: analytics?.id,
      businessId: analytics?.business_id,
      date: analytics?.date,
      totalScans: analytics?.total_scans,
      uniqueVisitors: analytics?.unique_visitors,
      conversionRate: parseFloat(analytics?.conversion_rate || 0),
      avgScansPerDay: parseFloat(analytics?.avg_scans_per_day || 0)
    }));
  }
};
